import loadable from '@loadable/component';
import { WithConditionalHydration } from '../../../../WithConditionalHydration';
import { domainService } from '../../../../../domain/services/domainService';

const AdInfoLoadable = loadable(() => import('./AdInfo'), {
  resolveComponent: components => components.AdInfo,
  ssr: false
});

const condition = () =>
  domainService.isRunningOnCMS() ||
  domainService.isLocalDomain(window.location.hostname);

export const AdInfo = WithConditionalHydration(AdInfoLoadable, condition);
